import React               from 'react';
import validator           from 'validator';
import { Modal }           from 'react-bootstrap';
import TextComponent       from './base/TextComponent';
import TextAreaComponent   from './base/TextAreaComponent';

class EmailQuote extends React.Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeNote = this.changeNote.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.validate = this.validate.bind(this);

    this.emailChange = this.emailChange.bind(this);
    this.emailValidate = this.emailValidate.bind(this);
    this.emailBlur = this.emailBlur.bind(this);
    this.renderButton = this.renderButton.bind(this)

    this.state = {
      show : false,
      email: '',
      note : '',

      emailError: null,
      emailValid: null,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSend() {
    if (!this.validate()) return;
    // this.props.onSendEmailQuote(
    //   {
    //     product_quote_email_request: {
    //       email: this.state.email,
    //       note: this.state.note,
    //     },
    //     product_quote_number: this.props.parameters.get('product_quote_number'),
    //   },
    //   document.getElementsByName('authenticity_token')[0].value,
    // );

    if (this.props.onSendEmailQuote) {
      this.props.onSendEmailQuote({
        email: this.state.email,
        note: this.state.note,
      })
    }

    this.setState({ show: false });
  }

  changeNote(e) {
    this.setState({ note: e.target.value });
  }

  validate() {
    let valid = true;
    if (!this.emailValidate()) {
      valid = false;
      this.setState({ emailError: 'Email incorrect' });
    }
    return valid;
  }

  emailChange(e) {
    this.setState({ email: e.target.value });
    if (this.state.emailValid !== null) {
      this.emailValidate(e.target.value);
    }
  }

  emailValidate(email = null) {
    const value = email || this.state.email;
    if (validator.isEmail(value)) {
      this.setState({
        emailError: '',
        emailValid: true,
      });
      return true;
    }
    this.setState({
      emailError: 'Email incorrect',
      emailValid: false,
    });
    return false;
  }

  emailBlur() {
    if (this.state.emailValid === null) {
      return;
    }
    this.emailValidate();
  }

  renderButton() {
    return (
      <button
        type="button"
        className="btn btn-outline-gray btn-thin me-1"
        onClick={this.handleShow}>
        <i className="fas fa-envelope" /> EMAIL THIS QUOTE
      </button>
    )
  }

  render() {
    return (
      <div className="email-quote">
        {this.renderButton()}
        <Modal show={this.state.show} onHide={this.handleClose} className="email-quote-modal" centered>
          <Modal.Header closeButton>
            <Modal.Title>Email Quote</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <TextComponent
                  label="Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.emailChange}
                  onBlur={this.emailBlur}
                  data={{ 'data-rule-required': 'true' }}
                  groupName="product_quote_email_request">
                  <label htmlFor="product_quote_email_request[email]" className="error">
                    {this.state.emailError}
                  </label>
                </TextComponent>

              </div>
              <div className="col-md-12">
                <TextAreaComponent
                  label="Add a Note"
                  name="note"
                  onChange={this.changeNote}
                  value={this.state.note}
                  groupName="product_quote_email_request" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-primary" onClick={this.handleSend}>
              <i className="fas fa-paper-plane" /> Send Email
            </button>
          </Modal.Footer>
        </Modal>
        {this.props.children}
      </div>
    );
  }
}

export default EmailQuote;
